"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ObjectVersionList_1 = require("./_ObjectVersionList");
var _DeleteMarkers_1 = require("./_DeleteMarkers");
var _CommonPrefixList_1 = require("./_CommonPrefixList");
exports.ListObjectVersionsOutput = {
    type: "structure",
    required: [],
    members: {
        IsTruncated: {
            shape: {
                type: "boolean"
            }
        },
        KeyMarker: {
            shape: {
                type: "string"
            }
        },
        VersionIdMarker: {
            shape: {
                type: "string"
            }
        },
        NextKeyMarker: {
            shape: {
                type: "string"
            }
        },
        NextVersionIdMarker: {
            shape: {
                type: "string"
            }
        },
        Versions: {
            shape: _ObjectVersionList_1._ObjectVersionList,
            locationName: "Version"
        },
        DeleteMarkers: {
            shape: _DeleteMarkers_1._DeleteMarkers,
            locationName: "DeleteMarker"
        },
        Name: {
            shape: {
                type: "string"
            }
        },
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Delimiter: {
            shape: {
                type: "string"
            }
        },
        MaxKeys: {
            shape: {
                type: "integer"
            }
        },
        CommonPrefixes: {
            shape: _CommonPrefixList_1._CommonPrefixList
        },
        EncodingType: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=ListObjectVersionsOutput.js.map